import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-opacity": ".15",
  d: "M4.68 8.503a6.95 6.95 0 0 1 5.177-5.177 12.35 12.35 0 0 1 5.64 0 6.95 6.95 0 0 1 5.177 5.177 12.35 12.35 0 0 1 0 5.64 6.95 6.95 0 0 1-5.177 5.177 12.35 12.35 0 0 1-5.64 0 6.95 6.95 0 0 1-5.177-5.177 12.35 12.35 0 0 1 0-5.64"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-opacity": ".15",
  d: "M5.361 15.914a2.547 2.547 0 1 0 2.725 2.725 6.95 6.95 0 0 1-2.725-2.725"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m4.68 14.143.73-.171zm0-5.64-.73-.171zm15.994 0-.73.171zm0 5.64.73.172zm-5.177 5.177-.171-.73zm-5.64 0 .171-.73zm0-15.994.171.73zm5.64 0-.171.73zM5.361 15.914l.657-.363-.232-.42-.479.034zm2.725 2.725.749.054.034-.479-.42-.232zm1.026-9.594a.75.75 0 0 0 0 1.5zm3.056 1.5a.75.75 0 0 0 0-1.5zm-2.038 1.556a.75.75 0 1 0 0 1.5zm5.093 1.5a.75.75 0 0 0 0-1.5zm-9.813.371a11.6 11.6 0 0 1 0-5.298l-1.46-.342a13.1 13.1 0 0 0 0 5.983zm14.534-5.298a11.6 11.6 0 0 1 0 5.298l1.46.343a13.1 13.1 0 0 0 0-5.983zm-4.618 9.916a11.6 11.6 0 0 1-5.298 0l-.343 1.46c1.968.462 4.016.462 5.983 0zM10.028 4.057a11.6 11.6 0 0 1 5.298 0l.342-1.46a13.1 13.1 0 0 0-5.983 0zm0 14.533a6.2 6.2 0 0 1-4.618-4.618l-1.46.343a7.7 7.7 0 0 0 5.735 5.735zm5.64 1.46a7.7 7.7 0 0 0 5.736-5.735l-1.46-.343a6.2 6.2 0 0 1-4.618 4.618zm-.342-15.993a6.2 6.2 0 0 1 4.618 4.617l1.46-.342a7.7 7.7 0 0 0-5.736-5.736zm-5.64-1.46A7.7 7.7 0 0 0 3.95 8.331l1.46.342a6.2 6.2 0 0 1 4.618-4.617zm-4.38 12.568a3.297 3.297 0 0 0-3.057 3.287h1.5c0-.947.735-1.724 1.665-1.791zM2.25 18.453a3.297 3.297 0 0 0 3.297 3.297v-1.5a1.797 1.797 0 0 1-1.797-1.797zm3.297 3.297a3.297 3.297 0 0 0 3.288-3.057l-1.497-.108a1.797 1.797 0 0 1-1.791 1.665zm2.902-3.768a6.2 6.2 0 0 1-2.431-2.43l-1.313.724a7.7 7.7 0 0 0 3.019 3.02zm.663-7.437h3.056v-1.5H9.112zm1.018 3.056h5.093v-1.5H10.13z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }